import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const tableLinkStyles = {
    color: 'inherit',
    textDecoration: 'underline',
    '&:visited': {
        color: 'inherit',
    },
    '&:hover': {
        color: 'inherit',
    },
    '&:active': {
        color: 'inherit',
    },
};

export const TableLink = styled('a')(tableLinkStyles);

export const TableRouterLink = styled(Link)(tableLinkStyles);
